<template>

  <div>
  <div class="loading_page" v-if="requestStatus || !accountData">
    <orbit-spinner
        :animation-duration="1000"
        :size="100"
        :color="'#0e96b1'"
    />
  </div>

  <b-tabs v-if="accountData"
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >

    <!-- general tab -->
    <b-tab active>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('General')}}</span>
      </template>
      <account-setting-general :errors="errors" @postData="profilePost" :auth-data="accountData"/>
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Change Password')}}</span>
      </template>

      
      
      <account-setting-password :errors="errors" :password-post="passwordPost" />
    </b-tab>

        <!-- <b-tab>

      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('User Notifications Settings')}}</span>
      </template>

      
      
      <account-setting-notification-setting :errors="errors" :password-post="passwordPost" />
    </b-tab> -->


    

        <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('User Daily Report Settings')}}</span>
      </template>

      
      
      <daily-report-setting />
    </b-tab>



        <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon
          icon="HomeIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Dashboard') }}</span>
      </template>

      
      
      <hidden-widgets  :user="this.$store.state.auth.userData.id"/>
    </b-tab>



    <!--/ change password tab -->


<!--    &lt;!&ndash; notification &ndash;&gt;-->
<!--    <b-tab>-->
<!--      &lt;!&ndash; title &ndash;&gt;-->
<!--      <template #title>-->
<!--        <feather-icon-->
<!--          icon="BellIcon"-->
<!--          size="18"-->
<!--          class="mr-50"-->
<!--        />-->
<!--        <span class="font-weight-bold">{{ $t('Notifications')}}</span>-->
<!--      </template>-->

<!--      <account-setting-notification-->
<!--        v-if="options.notification"-->
<!--        :notification-data="options.notification"-->
<!--      />-->
<!--    </b-tab>-->
  </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingInformation from './AccountSettingInformation.vue'
import AccountSettingSocial from './AccountSettingSocial.vue'
import AccountSettingNotification from './AccountSettingNotification.vue'

import useAccountSettings from './useAccountSettings'
import { OrbitSpinner } from 'epic-spinners'

import AccountSettingNotificationSetting   from './AccountSettingNotificationSetting.vue';

import  DailyReportSetting   from './dialy-reports/DailyReportSetting.vue'

import HiddenWidgets from './HiddenWidgets.vue'

export default {
  components: {
    OrbitSpinner,
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
    AccountSettingSocial,
    AccountSettingNotification,
    AccountSettingNotificationSetting,
    DailyReportSetting,
    HiddenWidgets
    
  },

  setup(props, { root }){

    const {

      accountData,
      profilePost, passwordPost,errors,
      requestStatus } = useAccountSettings(root)

    return {
      accountData,
      requestStatus,errors,
      profilePost, passwordPost
    }
  },
}
</script>
